import { render, staticRenderFns } from "./CurrencyTag.vue?vue&type=template&id=281d8309&"
import script from "./CurrencyTag.vue?vue&type=script&lang=js&"
export * from "./CurrencyTag.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyTag.vue?vue&type=style&index=0&id=281d8309&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports